
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/workspaceRightPanel/components/tabLabelWithIcon.scss.css.virtualfile';
        module.exports = {"label":"_label_1ssxh_1","text":"_text_1ssxh_7"};